import React, { useState } from 'react';
import { whatsappLink } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = ({ onScrollToForm }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (e, target) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    if (target === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="navigation-header">
      <div className="container">
        <div className="header-content">
          <a href="/" className="navigation-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/ix5k6uhe_1.1.jpg" 
              alt="ZenKo" 
              className="logo-header"
            />
          </a>
          
          <nav className={`navigation-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
            <a href="#productos" onClick={(e) => handleNavClick(e, '#productos')} className="navigation-link">Productos</a>
            <a href="#objetivos" onClick={(e) => handleNavClick(e, '#objetivos')} className="navigation-link">Objetivos</a>
            <a href="#testimonios" onClick={(e) => handleNavClick(e, '#testimonios')} className="navigation-link">Testimonios</a>
            <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="navigation-link">FAQ</a>
          </nav>

          <div className="navigation-utilities">
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-contact nav-btn"
            >
              Contáctanos
            </a>
            
            <button 
              className="mobile-menu-toggle" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {isMenuOpen && <div className="mobile-overlay" onClick={() => setIsMenuOpen(false)} />}
    </header>
  );
};

export default Header;
